var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2,
    stroke: "#3B9A45",
    d: "M18.196 0.945969L6.19597 12.946C6.0905 13.0513 5.94753 13.1105 5.79847 13.1105C5.64941 13.1105 5.50644 13.0513 5.40097 12.946L0.150969 7.69597C0.0516087 7.58934 -0.00248353 7.4483 8.76355e-05 7.30258C0.0026588 7.15685 0.0616926 7.01781 0.164752 6.91475C0.267812 6.81169 0.406851 6.75266 0.552577 6.75009C0.698303 6.74752 0.839338 6.80161 0.945969 6.90097L5.79847 11.7525L17.401 0.150969C17.5076 0.0516094 17.6486 -0.00248353 17.7944 8.76344e-05C17.9401 0.0026588 18.0791 0.0616933 18.1822 0.164753C18.2852 0.267813 18.3443 0.406852 18.3469 0.552578C18.3494 0.698303 18.2953 0.839338 18.196 0.945969Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.98c17eee0f20ce98c382c5b1f8e7c05c.svg";
export { ForwardRef as ReactComponent };